import React from "react"

import { IOVGetCoverageGeneralData } from "@common-shared/types/requestData/oneVerifyRequestData.types.ts"

import { COVERAGE_CONFIG } from "../../config/coverage.config"
import { HtmlHelper } from "../../helpers/html.helper"

export const ModalityCodeBadgeElement: React.FunctionComponent<{
    requestData: IOVGetCoverageGeneralData
}> = props => {
    const { modalityCode } = props.requestData

    return HtmlHelper.getHtmlWrappedBadge(
        `Service: ${COVERAGE_CONFIG.modalityCodeDisplayNameMapping[modalityCode]}`,
        undefined,
        undefined,
        undefined,
        "bg-brand-lilacLight border-brand-lilac",
    )
}
